var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBubblesUp2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1600,
    zoomAndPan: "magnify",
    viewBox: "0 0 1200 671.999997",
    height: 896,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "f41aff902a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "2baece90dd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#f41aff902a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -120,
    width: 1440,
    fill: "#000000",
    y: -67.2,
    height: 806.399996,
    fillOpacity: 0.42
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "60fa6aee89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 413.28125 0 L 413.28125 336 L 0 336 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae2be7552e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 9114274276
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26 200 L 28 200 L 28 203 L 26 203 Z M 26 200 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2521ceddae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "527f3db3b5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c297335794"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 168 93 L 177 93 L 177 101 L 168 101 Z M 168 93 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "95f6d63f53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ff3377d314"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "323a7d2902"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6 162 L 9 162 L 9 164 L 6 164 Z M 6 162 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6b79ed20c8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b3c2ba335f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "81d307bc57"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 35 133 L 41 133 L 41 139 L 35 139 Z M 35 133 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bf5cc5787a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e4fcc7eda0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eed3ee83f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 80 112 L 83 112 L 83 116 L 80 116 Z M 80 112 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ee29927e95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "be9c67932b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae298bf229"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 294 17 L 297 17 L 297 19 L 294 19 Z M 294 17 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "94c7f2becb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a4e18d3c28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d667c7b08b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 250 0 L 264 0 L 264 5 L 250 5 Z M 250 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a2a527f798"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2e6d37ba97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "31d7281971"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30 89 L 35 89 L 35 94 L 30 94 Z M 30 89 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "185351124e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3126d4b97a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b6fdea4ee6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 32 77 L 40 77 L 40 86 L 32 86 Z M 32 77 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "69bae67a9d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "56800946df"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a620e3cb4d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23 76 L 28 76 L 28 81 L 23 81 Z M 23 76 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c6074e5f1a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1ebfd9c253"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ced6ec8760"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 111 34 L 117 34 L 117 41 L 111 41 Z M 111 34 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "67bf722bc3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "652dde6510"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ddecb86287"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11 71 L 20 71 L 20 79 L 11 79 Z M 11 71 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b2e823becf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c6942f11ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f3273131f9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20 69 L 24 69 L 24 75 L 20 75 Z M 20 69 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2819f42da6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b9bbccbbba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9e0562fc62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24 69 L 26 69 L 26 70 L 24 70 Z M 24 69 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b7dcab223d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "96fc29f159"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "41d414ae47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7 73 L 11 73 L 11 77 L 7 77 Z M 7 73 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3ab289e26b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1670ae32b2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "48adfb2640"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 27 62 L 31 62 L 31 65 L 27 65 Z M 27 62 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3baa8d3dbc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fa5e3781cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0e42406f93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18 55 L 25 55 L 25 62 L 18 62 Z M 18 55 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "14ae08137a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4fe89caa09"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa9f5c58e3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 90 10 L 95 10 L 95 14 L 90 14 Z M 90 10 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8597961cbf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e9bb0f7fd6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba4e805af9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 26 38 L 29 38 L 29 41 L 26 41 Z M 26 38 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d4e073b76e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "713999bf90"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "70d8b1d647"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40 23 L 50 23 L 50 32 L 40 32 Z M 40 23 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5095d87587"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac8b0004ed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4199bf7718"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 84 8 L 87 8 L 87 10 L 84 10 Z M 84 8 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "17a01b7757"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "987df399ba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f9b6a58a21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30 22 L 33 22 L 33 24 L 30 24 Z M 30 22 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ee37ba9fa6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d5f99511b7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "230c6e605f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 13 L 47 13 L 47 15 L 45 15 Z M 45 13 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1ac3223471"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b467a03890"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1c110dd727"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4 4 L 13 4 L 13 10 L 4 10 Z M 4 4 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ce304191f2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b5c86e82bb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f41460b3fe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4 0 L 14 0 L 14 2 L 4 2 Z M 4 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "75a8ee961b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -567.148438 -326.960938 L 124.75 -627.871094 L 413.097656 35.140625 L -278.800781 336.050781 Z M -567.148438 -326.960938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9691111fbd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 413.324219 34.980469 L -278.574219 335.890625 L -566.921875 -327.121094 L 124.972656 -628.03125 Z M 413.324219 34.980469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "35c51cb740"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 414,
    y: 0,
    height: 336
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dc96b86506"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 414,
    y: 0,
    height: 336
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#2baece90dd)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0.000000000000009613)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dc96b86506)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#60fa6aee89)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae2be7552e)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0.000000000000009613)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#35c51cb740)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9114274276)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2521ceddae)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#527f3db3b5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 27.433594 202.257812 C 27.949219 201.59375 27.671875 200.875 26.949219 200.894531 C 26.453125 200.929688 26.144531 201.976562 26.449219 202.683594 C 26.636719 203.113281 26.929688 202.949219 27.433594 202.257812 Z M 27.433594 202.257812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c297335794)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#95f6d63f53)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ff3377d314)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 175.871094 99.195312 C 176.757812 98.042969 176.285156 96.785156 174.335938 95.074219 C 172.574219 93.542969 171.773438 93.378906 170.402344 94.265625 C 169.003906 95.164062 168.210938 96.535156 168.421875 97.683594 C 168.621094 98.988281 170.136719 100.703125 171.191406 100.863281 C 172.574219 101.101562 175.113281 100.21875 175.871094 99.195312 Z M 175.871094 99.195312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#323a7d2902)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6b79ed20c8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b3c2ba335f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 7.90625 162.5625 C 7.691406 162.070312 7.472656 161.984375 6.957031 162.316406 C 6.617188 162.539062 6.414062 162.917969 6.523438 163.164062 C 6.628906 163.410156 7.042969 163.523438 7.4375 163.421875 C 8.03125 163.273438 8.117188 163.054688 7.90625 162.5625 Z M 7.90625 162.5625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#81d307bc57)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bf5cc5787a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e4fcc7eda0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 39.785156 137.921875 C 40.949219 136.648438 41.035156 135.839844 40.179688 134.207031 C 39.71875 133.308594 38.238281 132.929688 37.101562 133.425781 C 35.5625 134.09375 35.207031 135.710938 36.1875 137.292969 C 36.605469 137.914062 37.320312 138.554688 37.792969 138.714844 C 38.765625 139.019531 38.765625 139.019531 39.785156 137.921875 Z M 39.785156 137.921875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eed3ee83f5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ee29927e95)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#be9c67932b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 82.71875 114.753906 C 83.390625 113.695312 82.25 112.328125 81.113281 112.824219 C 80.097656 113.261719 79.820312 114.300781 80.621094 114.71875 C 81.5 115.140625 82.429688 115.171875 82.71875 114.753906 Z M 82.71875 114.753906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae298bf229)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#94c7f2becb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a4e18d3c28)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 296.453125 17.925781 C 296.253906 17.46875 294.890625 17.4375 294.714844 17.878906 C 294.664062 18.011719 294.785156 18.289062 294.996094 18.523438 C 295.496094 19 296.707031 18.511719 296.453125 17.925781 Z M 296.453125 17.925781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d667c7b08b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a2a527f798)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2e6d37ba97)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 262.398438 2.378906 C 263.628906 0.417969 263.617188 -1.546875 262.3125 -4.125 C 260.710938 -7.300781 260.101562 -7.691406 256.964844 -7.351562 C 255.53125 -7.203125 254.03125 -6.953125 253.664062 -6.792969 C 252.863281 -6.445312 250.53125 -1.8125 250.296875 0.0078125 C 250.113281 1.257812 250.121094 1.363281 251.097656 2.179688 C 251.640625 2.671875 252.855469 3.277344 253.757812 3.507812 C 254.644531 3.777344 256.105469 4.203125 256.992188 4.476562 C 259.058594 5.109375 261.15625 4.308594 262.398438 2.378906 Z M 262.398438 2.378906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#31d7281971)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#185351124e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3126d4b97a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 34.050781 93.066406 C 34.441406 92.53125 34.707031 90.625 34.441406 90.011719 C 34.1875 89.429688 32.039062 88.863281 31.304688 89.183594 C 29.765625 89.851562 30.261719 93.507812 31.921875 93.882812 C 32.8125 94.082031 33.46875 93.832031 34.050781 93.066406 Z M 34.050781 93.066406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b6fdea4ee6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#69bae67a9d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#56800946df)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 36.742188 84.808594 C 36.871094 84.679688 37.339844 84.332031 37.761719 84.039062 C 38.179688 83.746094 38.664062 82.839844 38.859375 82.027344 L 39.21875 80.589844 L 37.953125 79.605469 C 35.246094 77.496094 32.425781 76.894531 32.046875 78.375 C 31.941406 78.640625 32.222656 80.125 32.621094 81.632812 L 33.34375 84.386719 L 34.714844 84.851562 C 36.042969 85.296875 36.222656 85.289062 36.742188 84.808594 Z M 36.742188 84.808594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a620e3cb4d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c6074e5f1a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1ebfd9c253)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 27.011719 79.652344 C 27.03125 79.023438 26.804688 78.5 26.109375 77.742188 C 25.34375 76.90625 25.019531 76.753906 24.40625 77.023438 C 23.914062 77.234375 23.6875 77.554688 23.785156 77.949219 C 23.945312 78.648438 25.488281 80.09375 26.402344 80.355469 C 26.90625 80.5 27.003906 80.386719 27.011719 79.652344 Z M 27.011719 79.652344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ced6ec8760)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#67bf722bc3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#652dde6510)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 115.675781 39.410156 C 116.378906 38.082031 116.292969 37.132812 115.421875 36.050781 C 114.378906 34.75 113.351562 34.648438 112.015625 35.777344 C 111.273438 36.429688 111.039062 36.898438 111.113281 37.742188 C 111.253906 39.652344 111.714844 40.292969 113.070312 40.472656 C 114.617188 40.675781 115.15625 40.476562 115.675781 39.410156 Z M 115.675781 39.410156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ddecb86287)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b2e823becf)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c6942f11ac)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 19.0625 76.496094 C 19.457031 75.886719 19.820312 74.960938 19.867188 74.394531 C 19.988281 73.5 19.878906 73.328125 18.636719 72.152344 C 17.449219 71.023438 17.15625 70.933594 16.09375 71.175781 C 13.203125 71.921875 12.351562 72.65625 11.671875 74.960938 C 11.308594 76.140625 11.34375 76.382812 11.949219 76.851562 C 13.253906 77.925781 15.320312 78.308594 17.339844 77.828125 C 18.113281 77.675781 18.570312 77.296875 19.0625 76.496094 Z M 19.0625 76.496094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f3273131f9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2819f42da6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b9bbccbbba)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 23.558594 73.8125 C 23.964844 71.808594 21.492188 68.972656 20.515625 70.347656 C 20.273438 70.710938 20.277344 71.21875 20.523438 71.621094 C 20.730469 72.007812 21.113281 72.644531 21.363281 73.046875 C 21.582031 73.464844 21.914062 73.976562 22.035156 74.253906 C 22.488281 75.042969 23.355469 74.773438 23.558594 73.8125 Z M 23.558594 73.8125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9e0562fc62)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b7dcab223d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#96fc29f159)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 25.433594 69.304688 C 25.300781 68.996094 24.945312 68.933594 24.574219 69.09375 C 23.839844 69.414062 24.238281 70.082031 25.074219 69.902344 C 25.40625 69.828125 25.554688 69.582031 25.433594 69.304688 Z M 25.433594 69.304688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#41d414ae47)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3ab289e26b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1670ae32b2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 10.171875 75.796875 C 10.503906 74.957031 8.789062 73.035156 8.023438 73.371094 C 7.285156 73.691406 7.148438 75.394531 7.824219 75.941406 C 8.386719 76.390625 9.984375 76.28125 10.171875 75.796875 Z M 10.171875 75.796875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#48adfb2640)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3baa8d3dbc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fa5e3781cd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 30.101562 64.242188 C 30.65625 63.671875 30.601562 62.453125 29.957031 62.148438 C 29.257812 61.796875 28.089844 62.304688 27.851562 63.101562 C 27.703125 63.605469 27.84375 63.835938 28.507812 64.277344 C 29.367188 64.820312 29.515625 64.828125 30.101562 64.242188 Z M 30.101562 64.242188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0e42406f93)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#14ae08137a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4fe89caa09)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 23.480469 60.109375 C 24.566406 58.90625 24.671875 58.3125 24.042969 56.867188 C 23.46875 55.546875 22.714844 55.070312 21.433594 55.152344 C 19.703125 55.285156 18.863281 55.796875 18.425781 56.972656 C 18.050781 57.867188 18.113281 58.351562 18.726562 59.765625 C 19.367188 61.238281 19.582031 61.476562 20.257812 61.4375 C 22.109375 61.324219 22.523438 61.183594 23.480469 60.109375 Z M 23.480469 60.109375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa9f5c58e3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8597961cbf)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e9bb0f7fd6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 93.816406 13.003906 C 94.378906 12.285156 93.855469 11.160156 92.726562 10.667969 C 91.566406 10.183594 91.289062 10.304688 90.855469 11.40625 C 90.421875 12.507812 90.753906 13.351562 91.769531 13.675781 C 92.667969 13.980469 93.25 13.800781 93.816406 13.003906 Z M 93.816406 13.003906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba4e805af9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d4e073b76e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#713999bf90)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 28.730469 39.339844 C 29.082031 38.710938 29.054688 38.648438 28.394531 38.390625 C 27.46875 38.023438 26.433594 38.839844 26.78125 39.640625 C 27.085938 40.34375 28.253906 40.167969 28.730469 39.339844 Z M 28.730469 39.339844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#70d8b1d647)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5095d87587)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac8b0004ed)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 46.019531 29.773438 C 46.582031 29.054688 47.269531 28.535156 47.800781 28.414062 C 48.847656 28.214844 49.152344 27.828125 49.242188 26.691406 C 49.316406 25.601562 48.898438 24.722656 47.890625 23.917969 C 46.757812 22.988281 46.285156 23.082031 45.027344 24.46875 C 44.085938 25.5 43.804688 25.695312 42.675781 25.785156 C 40.429688 25.996094 39.410156 28.191406 41.078125 29.253906 C 41.5 29.546875 42.015625 29.726562 42.167969 29.660156 C 42.320312 29.59375 42.875 29.9375 43.375 30.414062 C 44.429688 31.414062 44.734375 31.355469 46.019531 29.773438 Z M 46.019531 29.773438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4199bf7718)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#17a01b7757)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#987df399ba)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 86.480469 9.328125 C 86.542969 8.714844 85.976562 8.414062 85.269531 8.722656 C 84.839844 8.910156 84.765625 9.160156 84.972656 9.472656 C 85.363281 10.03125 86.375 9.921875 86.480469 9.328125 Z M 86.480469 9.328125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f9b6a58a21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ee37ba9fa6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d5f99511b7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 32.304688 23.023438 C 32.394531 22.21875 32.042969 22.003906 31.277344 22.339844 C 30.539062 22.660156 30.503906 23.332031 31.160156 23.667969 C 31.949219 24.054688 32.242188 23.890625 32.304688 23.023438 Z M 32.304688 23.023438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#230c6e605f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1ac3223471)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b467a03890)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 45.96875 13.867188 C 45.714844 13.867188 45.449219 14.019531 45.398438 14.152344 C 45.316406 14.296875 45.539062 14.308594 45.863281 14.132812 C 46.203125 13.984375 46.253906 13.851562 45.96875 13.867188 Z M 45.96875 13.867188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1c110dd727)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ce304191f2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b5c86e82bb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 12.570312 8.8125 C 12.785156 8.132812 11.609375 6.015625 10.953125 5.933594 C 10.671875 5.875 10.21875 5.925781 9.941406 6.042969 C 9.664062 6.164062 9.148438 5.988281 8.777344 5.636719 C 8.40625 5.289062 7.890625 5.109375 7.613281 5.230469 C 7.367188 5.335938 7.035156 5.152344 6.898438 4.847656 C 6.566406 4.078125 5.984375 4.003906 5.292969 4.597656 C 4.632812 5.175781 5.066406 5.753906 6.011719 5.488281 C 6.40625 5.390625 6.738281 5.320312 6.753906 5.347656 C 6.765625 5.378906 6.855469 5.925781 6.945312 6.542969 C 7.042969 7.523438 7.28125 7.824219 8.574219 8.613281 C 9.457031 9.214844 10.503906 9.527344 11.183594 9.488281 C 12.523438 9.378906 12.382812 9.476562 12.570312 8.8125 Z M 12.570312 8.8125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f41460b3fe)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#75a8ee961b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9691111fbd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6b989",
    d: "M 11.59375 -0.410156 C 13.171875 -1.316406 14.144531 -4.113281 13.445312 -5.636719 C 13.136719 -6.269531 12.476562 -7.113281 11.957031 -7.546875 C 10.980469 -8.363281 10.535156 -8.386719 7.921875 -8.09375 C 6.578125 -7.910156 6.390625 -7.828125 5.828125 -6.851562 C 5.5 -6.269531 5.109375 -5.738281 4.957031 -5.667969 C 4.15625 -5.324219 4.296875 -3.996094 5.300781 -1.691406 C 6.265625 0.445312 6.503906 0.746094 7.375 0.988281 C 8.335938 1.261719 9.101562 1.003906 11.59375 -0.410156 Z M 11.59375 -0.410156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubblesUp2);
export default __webpack_public_path__ + "static/media/bubbles-up-2.dc8edaff9eceb8c7335dacbc6af7b936.svg";
export { ForwardRef as ReactComponent };